const state = {
  //Searching Components
  searchedStudentHistory: sessionStorage.getItem('student-history')
    ? JSON.parse(sessionStorage.getItem('student-history'))
    : [],
  searchOpened: false,
  showFastSearch: false,
  showSelectedStudent: sessionStorage.getItem('showSelectedStudent')
    ? JSON.parse(sessionStorage.getItem('showSelectedStudent'))
    : null,
  selectedStudent: sessionStorage.getItem('selected-student')
    ? JSON.parse(sessionStorage.getItem('selected-student'))
    : null,
  details: sessionStorage.getItem('selected-student-details')
    ? JSON.parse(sessionStorage.getItem('selected-student-details'))
    : null,
  studentId: sessionStorage.getItem('selected-student')
    ? JSON.parse(sessionStorage.getItem('selected-student')).studentId
    : null,
  alerts: [],
  //Registery Module
  selectedStudentPreRegistry: {
    regStudentId: '',
    academicYearId: 0,
    statusId: 0,
    isReadMode: false,
    registrationDate: null,
    isReadModePostRegistry: false,
    isPostRegistry: false,
  },
  studentPreRegistryValidations: [],
  register: null,
  regStudentId: null,
  isStudentRegistryPropagation: {
    value: false,
    validateTab1: false,
    date: new Date(),
  },
  ShowModal: false, //Show Modal
  sieForModal: '', //Set Student for "view student information"
  navigateToViewDisplay: false,
};
export default state;
